module.exports = __webpack_public_path__ + "img/empty.25aded1e.png";